/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, September 24th 2021, 12:10:22 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { SetupStepper } from "onboarding/components/SetupStepper";
import { SetupWelcomeStep } from "onboarding/components/SetupWelcomeStep";
import { SetupOrganizationStep } from "onboarding/components/SetupOrganizationStep";
import { SetupPortalsStep } from "onboarding/components/SetupPortalsStep";
import { SetupInviteWorkersStep } from "onboarding/components/SetupInviteWorkersStep";
import { SetupBillingStep } from "onboarding/components/SetupBillingStep";
import { useOnboardingContext } from "onboarding/providers/OnboardingProvider";
import { APIItemDisplayWrapper } from "ui-widgets/wrappers/APIRequestWrappers";
import { useGlobalScope } from "core/providers";

export const SetupPage = () => {
  const {
    onboardingState: { onboardingStep },
  } = useOnboardingContext();

  const {
    globalState: { isFetchingGlobalOrganization, isGlobalOrganizationFetchError, globalOrganizationFetchStatusCode },
  } = useGlobalScope();

  return (
    <APIItemDisplayWrapper
      showLoader={isFetchingGlobalOrganization}
      httpResponseStatusCode={globalOrganizationFetchStatusCode}
      isAPIError={isGlobalOrganizationFetchError}
    >
      <SetupStepper step={onboardingStep}>
        <SetupWelcomeStep label="Welcome to Onestop" />
        <SetupOrganizationStep label="Setup Your Organization" />
        <SetupPortalsStep label="Setup a Portal" />
        <SetupInviteWorkersStep label="Invite Co-Workers" />
        <SetupBillingStep label="Choose a Plan" />
        {/* Let's have a final step as a close button */}
      </SetupStepper>
    </APIItemDisplayWrapper>
  );
};
